import {
  Card,
  Center,
  LoadingOverlay,
  Modal,
  Pagination,
  Table,
  Text,
} from '@mantine/core';
import useSWR from 'swr';
import { getFetcher } from '@/api/fetchers';
import { useState } from 'react';
import { type Audits } from '@/schemas/API/common/basic/audit';
import dayjs from 'dayjs';
import { dateTimeFormatUI } from '@/index';

interface AuditsModalProps {
  opened: boolean;
  close: () => void;
  type: string;
  id: string | undefined;
}

export const AuditsModal: React.FC<AuditsModalProps> = props => {
  const [activePage, setActivePage] = useState(1);

  const { data: audits, error } = useSWR<Audits>(
    `/${props.type}/${props.id}/audits?page=${activePage}&size=50`,
    getFetcher
  );

  if (error)
    return (
      <Modal
        opened={props.opened}
        onClose={props.close}
        title="Historie úprav"
        centered
      >
        <Text>Nepodařilo se načíst historii úprav.</Text>
      </Modal>
    );

  const rows = (audits?.content ?? []).map((element, elementId) => (
    <Table.Tr key={elementId}>
      <Table.Td>{element.action}</Table.Td>
      <Table.Td>{element.by.firstName + ' ' + element.by.lastName}</Table.Td>
      <Table.Td>{dayjs(element.time).format(dateTimeFormatUI)}</Table.Td>
    </Table.Tr>
  ));

  return (
    <Modal
      opened={props.opened}
      onClose={props.close}
      title="Historie úprav"
      centered
      size="lg"
    >
      <LoadingOverlay visible={!audits} data-testid="loading-overlay">
        <Text>Nahrávám historii úprav...</Text>
      </LoadingOverlay>
      <Card>
        <Table>
          <Table.Thead>
            <Table.Tr>
              <Table.Th>Typ úpravy</Table.Th>
              <Table.Th>Vytvořil</Table.Th>
              <Table.Th>Datum</Table.Th>
            </Table.Tr>
          </Table.Thead>
          <Table.Tbody>{rows}</Table.Tbody>
        </Table>
        <Center>
          <Pagination
            style={{ marginTop: '1rem' }}
            size="sm"
            total={audits?.totalPages ?? 1}
            value={activePage}
            onChange={setActivePage}
          />
        </Center>
      </Card>
    </Modal>
  );
};
